import { useMemorama } from '../context/MemoramaContext'
import MemoramaStart from './screens/MemoramaStart'
import MemoramaGame from './screens/MemoramaGame'
import MemoramaEnd from './screens/MemoramaEnd'
import { useDocumentMetadata } from '@hooks/useDocumentMetadata'
import { useNamespaces } from '@hooks/useNamespaces'
import { ROUTE_NAMESPACES } from '@i18n/namespaces'
import ScreenFallback from '@components/layout/ScreenFallback'

/**
 * MemoramaScreen - Orchestrates Memorama game flow
 *
 * Manages start → game → end transitions based on GameContext state.
 * Mirrors PuzzleScreen architecture for consistency.
 */
export default function MemoramaScreen () {
  useDocumentMetadata()

  const { gameStarted, isGameOver } = useMemorama()

  const { isLoading: namespacesLoading } = useNamespaces(ROUTE_NAMESPACES.memorama)
  if (namespacesLoading) {
    return <ScreenFallback />
  }

  // Game in progress
  if (gameStarted && !isGameOver) {
    return <MemoramaGame />
  }

  // Game finished
  if (isGameOver) {
    return <MemoramaEnd />
  }

  // Default: start screen
  return <MemoramaStart />
}
